(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var teardown = [];

  function cleanup() {
    teardown.splice(0).forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
  }

  function init() {
    cleanup();
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.hm-sec'));
    if (!sections.length) return;
    var hasIO = 'IntersectionObserver' in window;

    // Mark anything already on screen as revealed so nothing flashes hidden after load.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var reveals = Array.prototype.slice.call(main.querySelectorAll('.hm-reveal'));
    reveals.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add('is-in');
    });

    // Active colour theme follows the section crossing the middle of the viewport.
    var setTheme = function (section) { main.setAttribute('data-hm', section.getAttribute('data-hm-theme') || 'cream'); };
    var mid = vh / 2;
    var current = sections.filter(function (s) { var r = s.getBoundingClientRect(); return r.top <= mid && r.bottom >= mid; })[0] || sections[0];
    setTheme(current);
    main.classList.add('hm-live');
    teardown.push(function () { main.classList.remove('hm-live'); main.removeAttribute('data-hm'); });

    if (!hasIO) { reveals.forEach(function (el) { el.classList.add('is-in'); }); return; }

    var themeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) setTheme(entry.target); });
    }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    sections.forEach(function (s) { themeObserver.observe(s); });
    teardown.push(function () { themeObserver.disconnect(); });

    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { if (!el.classList.contains('is-in')) revealObserver.observe(el); });
    teardown.push(function () { revealObserver.disconnect(); });

    // Pause the ticker while offscreen.
    var tickers = Array.prototype.slice.call(main.querySelectorAll('.hm-ticker'));
    if (tickers.length) {
      var tickerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.target.classList.toggle('is-paused', !entry.isIntersecting); });
      });
      tickers.forEach(function (t) { t.classList.add('is-paused'); tickerObserver.observe(t); });
      teardown.push(function () { tickerObserver.disconnect(); });
    }

    // Project imagery: pointer parallax on fine pointers, scroll-linked drift everywhere else.
    var zones = Array.prototype.slice.call(main.querySelectorAll('[data-hm-zone]'));
    if (!zones.length || reduce.matches) return;
    var visible = new Set();
    var frame = null;
    var mode = null;

    var zoneObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
      if (mode === 'scroll') schedule();
    }, { rootMargin: '10% 0px 10% 0px' });
    zones.forEach(function (z) { zoneObserver.observe(z); });
    teardown.push(function () { zoneObserver.disconnect(); visible.clear(); });

    var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
    var scrollStep = function () {
      frame = null;
      var h = window.innerHeight || document.documentElement.clientHeight;
      visible.forEach(function (z) {
        var r = z.getBoundingClientRect();
        var p = clamp(((r.top + r.height / 2) - h / 2) / h, -1, 1);
        z.style.setProperty('--hm-sy', p.toFixed(3));
      });
    };
    var schedule = function () { if (frame === null && visible.size) frame = window.requestAnimationFrame(scrollStep); };
    var onMove = function (event) {
      var z = event.currentTarget;
      var r = z.getBoundingClientRect();
      if (!r.width || !r.height) return;
      z.style.setProperty('--hm-px', clamp(((event.clientX - r.left) / r.width - 0.5) * 2, -1, 1).toFixed(3));
      z.style.setProperty('--hm-py', clamp(((event.clientY - r.top) / r.height - 0.5) * 2, -1, 1).toFixed(3));
    };
    var onLeave = function (event) {
      event.currentTarget.style.setProperty('--hm-px', '0');
      event.currentTarget.style.setProperty('--hm-py', '0');
    };

    var bindPointer = function () { zones.forEach(function (z) { z.addEventListener('pointermove', onMove); z.addEventListener('pointerleave', onLeave); }); };
    var unbindPointer = function () { zones.forEach(function (z) { z.removeEventListener('pointermove', onMove); z.removeEventListener('pointerleave', onLeave); z.style.setProperty('--hm-px', '0'); z.style.setProperty('--hm-py', '0'); }); };
    var bindScroll = function () { window.addEventListener('scroll', schedule, { passive: true }); window.addEventListener('resize', schedule, { passive: true }); schedule(); };
    var unbindScroll = function () { window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule); if (frame !== null) window.cancelAnimationFrame(frame); frame = null; zones.forEach(function (z) { z.style.setProperty('--hm-sy', '0'); }); };
    var sync = function () {
      var next = finePointer.matches ? 'pointer' : 'scroll';
      if (next === mode) return;
      if (mode === 'pointer') unbindPointer();
      if (mode === 'scroll') unbindScroll();
      mode = next;
      if (mode === 'pointer') bindPointer(); else bindScroll();
    };
    sync();
    var onMq = function () { sync(); };
    if (finePointer.addEventListener) finePointer.addEventListener('change', onMq); else finePointer.addListener(onMq);
    teardown.push(function () {
      if (finePointer.removeEventListener) finePointer.removeEventListener('change', onMq); else finePointer.removeListener(onMq);
      if (mode === 'pointer') unbindPointer();
      if (mode === 'scroll') unbindScroll();
      mode = null;
    });
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { window.requestAnimationFrame(init); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
